module.exports = "<app-communications-post [sectionSubjectId]=\"sectionSubjectId\"></app-communications-post>\r\n"